import { render, staticRenderFns } from "./returnRequest.vue?vue&type=template&id=4f3f4f19&scoped=true"
import script from "./returnRequest.vue?vue&type=script&lang=js"
export * from "./returnRequest.vue?vue&type=script&lang=js"
import style0 from "./returnRequest.vue?vue&type=style&index=0&id=4f3f4f19&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f4f19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3f4f19')) {
      api.createRecord('4f3f4f19', component.options)
    } else {
      api.reload('4f3f4f19', component.options)
    }
    module.hot.accept("./returnRequest.vue?vue&type=template&id=4f3f4f19&scoped=true", function () {
      api.rerender('4f3f4f19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/returned/returnRequest.vue"
export default component.exports